export const FILTER_TYPES = {
  TEXT: "text",
  INTEGER: "integer",
  DECIMAL: "decimal",
  DATE: "date",
  DATE_RANGE: "date_range",
  SELECT: "select",
  BOOLEAN: "boolean",
  SINGLE_SELECT: "single_select"
} as const;

export const BOOLEAN_FILTER_OPTIONS = [
  { label: "True", value: "true" },
  { label: "False", value: "false" }
] as const;
